module.exports = __webpack_public_path__ + "img/business.426bfd8e.svg";